var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.config.title,
        visible: _vm.dialogVisible,
        width: _vm.config.width,
        "append-to-body": true,
        "before-close": _vm.handleClose,
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: {
            model: _vm.formData,
            rules: _vm.rules,
            "label-width": _vm.labelWidth,
          },
        },
        [
          _vm.config.type === 1 || _vm.config.type === 3
            ? _c(
                "div",
                [
                  _c(
                    "el-form-item",
                    { staticClass: "mt20" },
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _c("span", { staticClass: "color-tab" }, [_vm._v("*")]),
                        _vm._v("\n          职等区间：\n        "),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "levelMin" } },
                            [
                              _c("el-input-number", {
                                attrs: {
                                  placeholder: "最低职等",
                                  min: 0,
                                  controls: false,
                                },
                                model: {
                                  value: _vm.formData.levelMin,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "levelMin", $$v)
                                  },
                                  expression: "formData.levelMin",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { staticClass: "text-center line", attrs: { span: 2 } },
                        [_c("el-divider")],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "levelMax" } },
                            [
                              _c("el-input-number", {
                                attrs: {
                                  placeholder: "最高职等",
                                  min: _vm.formData.levelMin,
                                  controls: false,
                                },
                                model: {
                                  value: _vm.formData.levelMax,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "levelMax", $$v)
                                  },
                                  expression: "formData.levelMax",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { staticClass: "mt20" },
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _c("span", { staticClass: "color-tab" }, [_vm._v("*")]),
                        _vm._v("\n          薪资区间：\n        "),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "salaryMin" } },
                            [
                              _c("el-input-number", {
                                attrs: {
                                  placeholder: "最低薪资",
                                  min: 0,
                                  controls: false,
                                },
                                model: {
                                  value: _vm.formData.salaryMin,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "salaryMin", $$v)
                                  },
                                  expression: "formData.salaryMin",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { staticClass: "text-center line", attrs: { span: 2 } },
                        [_c("el-divider")],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "salaryMax" } },
                            [
                              _c("el-input-number", {
                                attrs: {
                                  placeholder: "最高薪资",
                                  min: _vm.formData.salaryMin,
                                  controls: false,
                                },
                                model: {
                                  value: _vm.formData.salaryMax,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "salaryMax", $$v)
                                  },
                                  expression: "formData.salaryMax",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.config.type === 2
            ? _c(
                "div",
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "mt20",
                      attrs: { label: "每级职等跨度:", prop: "rank" },
                    },
                    [
                      _c("el-input-number", {
                        attrs: {
                          placeholder: "请输入职等跨度",
                          controls: false,
                        },
                        model: {
                          value: _vm.formData.rank,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "rank", $$v)
                          },
                          expression: "formData.rank",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "mt20",
                      staticStyle: { "margin-bottom": "0" },
                      attrs: { label: "跨度说明:" },
                    },
                    [
                      _c("div", { staticClass: "rank-explain" }, [
                        _c("p", [
                          _vm._v(
                            "1. 批量设置职等跨度，跨度只能为正整数，不能为负数；"
                          ),
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v("2. 职等跨度示例：1-4，跨度数字为4。"),
                        ]),
                      ]),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.handleClose } },
            [_vm._v(_vm._s(_vm.$t("public.cancel")))]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "primary", loading: _vm.loading },
              on: { click: _vm.handleConfirm },
            },
            [_vm._v(_vm._s(_vm.$t("public.ok")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }